import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, MaskLines, Reveal } from "./Motion";
import { ABOUT_IMAGE } from "../data/content";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="about" ref={ref} data-testid="about-section" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-10 sm:py-36">
      <div className="grid items-center gap-14 lg:grid-cols-12">
        <Reveal className="lg:col-span-5">
          <div className="relative aspect-[4/5] overflow-hidden bg-[#EDE8E1]">
            <motion.img style={{ y, scale: 1.18 }} src={ABOUT_IMAGE} alt="Ulyana Shmidt, personal stylist" className="h-full w-full object-cover object-[center_75%]" data-testid="about-image" />
          </div>
        </Reveal>
        <div className="lg:col-span-6 lg:col-start-7">
          <Eyebrow>About Ulyana</Eyebrow>
          <h2 className="mt-6 font-display text-4xl leading-[1.04] sm:text-5xl lg:text-6xl">
            <MaskLines lines={["Style is not about age.", <span key="i" className="italic text-[#8A6A3E]">It's about clarity.</span>]} />
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-8 text-lg leading-relaxed text-[#3A3632]">
              I'm Ulyana Shmidt, a personal stylist in New York. I work mostly with women over 40 — women who have built careers, families and lives, and want their wardrobe to finally keep up.
            </p>
            <p className="mt-5 text-lg leading-relaxed text-[#5E5953]">
              My approach is simple: fewer, better pieces, clear combinations, and clothes that respect your body and your time. No trends for the sake of trends — just a style that feels like you, every single day.
            </p>
            <p className="mt-10 font-display text-4xl italic text-[#1A1816]">Ulyana Shmidt</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
